<app-demo-badge></app-demo-badge>
<div
  class="page-container p-0 m-0"
  [style.--promo-banner-h.px]="isShowBonusBanner() ? 40 : 0"
>
  <div *ngIf="showSplashScreen" class="overflow-hidden overflow-y-hidden">
    <app-splash-screen (finished)="onSplashFinished()"></app-splash-screen>
  </div>

  <div *ngIf="!showSplashScreen" class="content-wrap">
    <!-- Signup Bonus Promo Ticker Banner -->
    <div
      *ngIf="isShowBonusBanner()"
      class="bonus-banner-container"
      (click)="redirectToSignup()"
    >
      <div class="bonus-scroll-container">
        <div class="bonus-scroll-content">
          <span class="bonus-scroll-item">
            <span class="bonus-scroll-icon">🎁</span>
            <span class="bonus-scroll-highlight">{{ signupBonus > 0 ? signupBonus + "%" : "AMAZING" }} SIGNUP BONUS</span>
            <span class="bonus-scroll-text">ON YOUR FIRST DEPOSIT!</span>
          </span>
          <span class="bonus-scroll-item">
            <span class="bonus-scroll-icon">🔥</span>
            <span class="bonus-scroll-highlight">SIGN UP NOW</span>
            <span class="bonus-scroll-text">TO CLAIM YOUR EXCLUSIVE BONUS!</span>
          </span>
          <span class="bonus-scroll-item">
            <span class="bonus-scroll-icon">💎</span>
            <span class="bonus-scroll-highlight">LIMITED TIME OFFER</span>
            <span class="bonus-scroll-text">DON'T MISS OUT!</span>
          </span>
          <span class="bonus-scroll-item">
            <span class="bonus-scroll-icon">💰</span>
            <span class="bonus-scroll-highlight">{{ signupBonus > 0 ? signupBonus + "%" : "AMAZING" }} SIGNUP BONUS</span>
            <span class="bonus-scroll-text">ON YOUR NEXT WIN!</span>
          </span>
          <!-- duplicate set for seamless loop -->
          <span class="bonus-scroll-item">
            <span class="bonus-scroll-icon">🎁</span>
            <span class="bonus-scroll-highlight">{{ signupBonus > 0 ? signupBonus + "%" : "AMAZING" }} SIGNUP BONUS</span>
            <span class="bonus-scroll-text">ON YOUR FIRST DEPOSIT!</span>
          </span>
          <span class="bonus-scroll-item">
            <span class="bonus-scroll-icon">🔥</span>
            <span class="bonus-scroll-highlight">SIGN UP NOW</span>
            <span class="bonus-scroll-text">TO CLAIM YOUR EXCLUSIVE BONUS!</span>
          </span>
          <span class="bonus-scroll-item">
            <span class="bonus-scroll-icon">💎</span>
            <span class="bonus-scroll-highlight">LIMITED TIME OFFER</span>
            <span class="bonus-scroll-text">DON'T MISS OUT!</span>
          </span>
          <span class="bonus-scroll-item">
            <span class="bonus-scroll-icon">💰</span>
            <span class="bonus-scroll-highlight">{{ signupBonus > 0 ? signupBonus + "%" : "AMAZING" }} SIGNUP BONUS</span>
            <span class="bonus-scroll-text">ON YOUR NEXT WIN!</span>
          </span>
        </div>
      </div>
    </div>

    <app-header
      *ngIf="shouldshowheader()"
      (openChatFromHeader)="openChatHandler()"
    ></app-header>
    <div *ngIf="addBalance">
      <app-add-wallet [showModal]="addBalance"></app-add-wallet>
    </div>
    <router-outlet></router-outlet>

    <ng-container *ngIf="shouldShowChat()">
      <div class="fixed bottom-16 right-4 z-[999] hidden lg:block">
        <button
          class="chat-fab hidden md:flex"
          (click)="toggleChat()"
          aria-label="Open chat"
        >
          <!-- Unread Message Count Badge -->
          <span *ngIf="unreadCounts > 0" class="chat-fab-badge">
            {{ unreadCounts > 99 ? "99+" : unreadCounts }}
          </span>
          <svg
            width="28"
            height="28"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <defs>
              <linearGradient
                id="chatFabGrad"
                x1="0"
                y1="0"
                x2="24"
                y2="24"
                gradientUnits="userSpaceOnUse"
              >
                <stop offset="0%" stop-color="#E7C98B" />
                <stop offset="50%" stop-color="#F2A56F" />
                <stop offset="100%" stop-color="#D946EF" />
              </linearGradient>
            </defs>
            <path
              d="M6 2H21C22.1 2 23 2.9 23 4V13C23 14.1 22.1 15 21 15H14.5L10.5 18.5V15H6C4.9 15 4 14.1 4 13V4C4 2.9 4.9 2 6 2Z"
              fill="url(#chatFabGrad)"
            />
            <path
              d="M3 6H17C18.1 6 19 6.9 19 8V17C19 18.1 18.1 19 17 19H10.5L6.5 22.5V19H3C1.9 19 1 18.1 1 17V8C1 6.9 1.9 6 3 6Z"
              fill="url(#chatFabGrad)"
              opacity="0.45"
            />
          </svg>
        </button>
      </div>
      <app-chat *ngIf="isChatOpen"></app-chat>
    </ng-container>

    <!-- Redesigned Sovereign Floating Bonus Card -->
    <div *ngIf="isBonusButton()" class="fixed top-24 right-4 z-[999]">
      <div class="sovereign-bonus-card group" (click)="redirectToSignup()">
        <!-- Dismiss Button -->
        <button
          type="button"
          class="bonus-dismiss-btn"
          (click)="dismissBonusFloating($event)"
          aria-label="Dismiss bonus"
        >
          &times;
        </button>

        <!-- Golden Emblem with Pulse Ring -->
        <div class="bonus-emblem-wrap group-hover:scale-105 transition-transform">
          <div class="bonus-emblem-glow"></div>
          <img
            loading="lazy"
            src="/icons/gift-icon.png"
            alt="Gift"
            class="h-6 w-6 object-contain relative z-10"
            onerror="this.style.display = 'none'"
          />
        </div>

        <!-- Meta Text & Bonus Tier -->
        <div class="bonus-meta">
          <span class="bonus-pill-tag">
            <span class="pulse-dot"></span>
            LIMITED OFFER
          </span>
          <span class="bonus-headline">
            Avail <span class="highlight">{{ signupBonus > 0 ? signupBonus + "%" : "100%" }}</span> Bonus
          </span>
        </div>

        <!-- Action Pill -->
        <div class="bonus-cta-pill group-hover:brightness-110">
          Claim Now
        </div>
      </div>
    </div>

    <!-- Floating Install App Button (mirrors bonus button, left side) -->
    <div
      *ngIf="showInstallFloating && pwaInstall.canInstall() && shouldShowChat()"
      class="fixed top-[59%] left-4 z-[999]"
    >
      <!-- Close icon -->
      <span
        class="absolute -top-2 -right-2 w-5 h-5 flex items-center justify-center bg-black/60 rounded-full text-white/50 hover:text-white cursor-pointer z-10 text-xs border border-white/10"
        (click)="showInstallFloating = false"
        >✕</span
      >
      <button
        class="install-app-btn flex items-center gap-3 px-4 py-3 rounded-xl animate-bounce-slow transition-all group border border-[#E7CA96]/35 shadow-[0_12px_35px_rgba(0,0,0,0.75),0_0_20px_rgba(199,22,80,0.3)] hover:scale-105"
        style="
          background: linear-gradient(
            135deg,
            rgba(22, 10, 19, 0.97) 0%,
            rgba(13, 7, 12, 0.98) 100%
          );
        "
        (click)="installFloating()"
      >
        <div
          class="w-10 h-10 rounded-xl bg-gradient-to-br from-[#C71650] via-[#9B0F3B] to-[#680825] flex items-center justify-center shadow-[0_0_14px_rgba(199,22,80,0.6)] border border-[#E7CA96]/40 group-hover:scale-110 transition-transform"
        >
          <i class="fas fa-download text-[#FAF4EB]"></i>
        </div>
        <div class="flex flex-col items-start">
          <span
            class="text-[10px] uppercase tracking-wider text-[#E7CA96] font-extrabold"
            >Instant Web App</span
          >
          <span class="text-sm font-bold text-[#FAF4EB] whitespace-nowrap">
            Install App
          </span>
        </div>
      </button>
    </div>
  </div>

  <app-footer
    *ngIf="shouldshowheader()"
    [chatUnreadCount]="unreadCounts"
  ></app-footer>
  <!-- Fixed Cartoon Character -->
  <!-- <div *ngIf="showCharacterImage" class="fixed bottom-4 left-4 z-[1000] inline-block">
  
  <button 
    (click)="showCharacterImage = false" 
    class="absolute -top-2 -right-2 z-[1001] flex h-6 w-6 items-center justify-center rounded-full bg-red-500 text-xs text-white font-bold shadow-md transition-all hover:bg-red-600 hover:scale-110"
    type="button"
  >
    ✕
  </button>
  
  <img loading="lazy"
    src="/avatar.png"
    alt="Character"
    class="block"
  />
</div> -->
</div>

<!-- <app-coming-soon></app-coming-soon> -->

<app-user-manual></app-user-manual>
<app-common-modal></app-common-modal>

<app-devtools-guard-modal
  [visible]="devToolsWarning.visible()"
  [reason]="devToolsWarning.reason()"
  (dismissed)="devToolsWarning.hide()">
</app-devtools-guard-modal>

<div
  *ngIf="VerifyModal"
  class="fixed inset-0 wallet-modal-backdrop flex items-center justify-center z-[9999] px-3 sm:px-4 overflow-y-auto"
  (click)="closeDialog()"
>
  <div
    class="wallet-modal-shell w-full max-w-md my-auto"
    (click)="$event.stopPropagation()"
  >
    <!-- Header -->
    <div class="flex items-start justify-between gap-4 mb-5">
      <div>
        <h2 class="wallet-modal-title">Verify Your Account</h2>
        <p class="wallet-modal-subtitle">
          Account Verification Pending. Enter your email to receive a
          verification OTP.
        </p>
      </div>
      <button (click)="closeDialog()" class="wallet-modal-close">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          class="h-4 w-4"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        >
          <line x1="18" y1="6" x2="6" y2="18" />
          <line x1="6" y1="6" x2="18" y2="18" />
        </svg>
      </button>
    </div>

    <div class="space-y-4">
      <div>
        <label class="wallet-form-label">Email Address</label>
        <input
          #emailInput
          (input)="(0)"
          type="email"
          placeholder="Enter your email"
          class="wallet-form-input"
        />
      </div>

      <div class="relative">
        <label class="wallet-form-label">New Password</label>
        <input
          #passwordInput
          (input)="(0)"
          [type]="showPasswordText ? 'text' : 'password'"
          placeholder="Enter new password"
          class="wallet-form-input pr-10"
        />
        <button
          type="button"
          (click)="showPasswordText = !showPasswordText"
          class="absolute right-3 top-[65%] -translate-y-1/2 text-gray-400 hover:text-white transition-colors cursor-pointer"
        >
          <fa-icon [icon]="showPasswordText ? faEyeSlash : faEye"></fa-icon>
        </button>

        <div
          *ngIf="passwordInput.value"
          class="text-xs space-y-1 mt-1 px-1 text-left"
        >
          <div
            [class.text-green-400]="RULES.length.test(passwordInput.value)"
            [class.text-gray-500]="!RULES.length.test(passwordInput.value)"
          >
            ✓ Minimum 8 characters
          </div>
          <div
            [class.text-green-400]="RULES.uppercase.test(passwordInput.value)"
            [class.text-gray-500]="!RULES.uppercase.test(passwordInput.value)"
          >
            ✓ At least one uppercase letter
          </div>
          <div
            [class.text-green-400]="RULES.digit.test(passwordInput.value)"
            [class.text-gray-500]="!RULES.digit.test(passwordInput.value)"
          >
            ✓ At least one number digit
          </div>
          <div
            [class.text-green-400]="RULES.special.test(passwordInput.value)"
            [class.text-gray-500]="!RULES.special.test(passwordInput.value)"
          >
            ✓ At least one special symbol character
          </div>
        </div>
      </div>

      <div class="relative">
        <label class="wallet-form-label">Confirm New Password</label>
        <input
          #confirmPasswordInput
          (input)="(0)"
          [type]="showConfirmPasswordText ? 'text' : 'password'"
          placeholder="Confirm new password"
          class="wallet-form-input pr-10"
        />
        <button
          type="button"
          (click)="showConfirmPasswordText = !showConfirmPasswordText"
          class="absolute right-3 top-[65%] -translate-y-1/2 text-gray-400 hover:text-white transition-colors cursor-pointer"
        >
          <fa-icon
            [icon]="showConfirmPasswordText ? faEyeSlash : faEye"
          ></fa-icon>
        </button>

        <p
          *ngIf="
            confirmPasswordInput.value &&
            passwordInput.value !== confirmPasswordInput.value
          "
          class="text-red-400 text-xs mt-1 text-left px-1"
        >
          Passwords do not match.
        </p>
      </div>
    </div>

    <button
      type="button"
      (click)="sendOtpLogic(emailInput.value, passwordInput.value)"
      [disabled]="
        !emailInput.value ||
        !isPasswordValid(passwordInput.value) ||
        passwordInput.value !== confirmPasswordInput.value
      "
      class="wallet-btn-action w-full mt-5"
    >
      Send OTP
    </button>
  </div>
</div>
